import localforage from 'localforage'

class Transporteur
{
    static getList()
    {
        return new Promise((resolve, reject) => {
                localforage.getItem('listTransporteurs')
                    .then(data => resolve(_.sortBy(JSON.parse(data), ['raison_sociale'])))
                    .catch(err => reject(err))
        })
    }

    static async getTransporteur(idTransporteur)
    {
        return new Promise((resolve, reject) => {
            this.getList().then(data => {
                let transporteur = _.find(data, ['id', parseInt(idTransporteur)]);
                resolve(transporteur);
            }).catch(err => reject(err))
        })
    }
}

export default Transporteur



// WEBPACK FOOTER //
// ./src/js/models/Transporteur.js